import type { BackendTypes } from '@tf/api';
import type { EntityFormsContext } from '@/components/structure/getEntityForms';

interface NodeEditParams {
	stepConnectionKind: string;
	accountId: BackendTypes.GraphId;
	entityId: BackendTypes.GraphId;
	parentEntityId: BackendTypes.GraphId | null;
	isAccount: boolean;
	isMainEntity: boolean;
}

export const getNodeEditContext = ({
	stepConnectionKind,
	accountId,
	entityId,
	parentEntityId,
	isAccount,
	isMainEntity,
}: NodeEditParams): EntityFormsContext | null => {
	if (isAccount) {
		return null;
	}

	if (stepConnectionKind !== 'APPLICANT' && parentEntityId === accountId) {
		return { entityId, parentEntityId: accountId, connectionKind: stepConnectionKind };
	}

	if (isMainEntity) {
		return null;
	}

	return { entityId };
};
